

module.exports = __webpack_require__.stylable.create(
    "ColorPickerItem2577026692",
    {"classes":{"root":"ColorPickerItem2577026692__root","radioOuter":"ColorPickerItem2577026692__radioOuter","radioInner":"ColorPickerItem2577026692__radioInner"},"vars":{},"stVars":{"DefaultItemSize":"24px","DefaultBorderRadius":"12px"},"keyframes":{}},
    "",
    4,
    "ColorPickerItem2577026692",
    null
);
